module.exports = __webpack_public_path__ + "media/niacinamide-large.97e31a9c.mp4";